import { render, staticRenderFns } from "./scope123.vue?vue&type=template&id=e835e2b8&scoped=true"
import script from "./scope123.vue?vue&type=script&lang=js"
export * from "./scope123.vue?vue&type=script&lang=js"
import style0 from "./scope123.vue?vue&type=style&index=0&id=e835e2b8&prod&lang=scss&scoped=true"
import style1 from "./scope123.vue?vue&type=style&index=1&id=e835e2b8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e835e2b8",
  null
  
)

export default component.exports